import { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Register SW for PWA
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw-push.js', { scope: '/' }).catch(() => {});
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Only show if user hasn't dismissed recently
      const dismissed = localStorage.getItem('pwa-dismissed');
      if (!dismissed || Date.now() - parseInt(dismissed) > 86400000) {
        setShow(true);
      }
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShow(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem('pwa-dismissed', Date.now().toString());
  };

  if (!show) return null;

  return (
    <div
      data-testid="pwa-install-prompt"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 glass-dark rounded-2xl p-4 shadow-2xl border border-gray-200 animate-in slide-in-from-bottom"
    >
      <button onClick={handleDismiss} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-center space-x-3">
        <div className="w-12 h-12 bg-coral rounded-xl flex items-center justify-center flex-shrink-0">
          <Download className="w-6 h-6 text-white" />
        </div>
        <div className="flex-1">
          <p className="font-semibold text-sm">Install Culture-Meet</p>
          <p className="text-xs text-gray-500">Add to home screen for a better experience</p>
        </div>
        <Button
          data-testid="pwa-install-btn"
          onClick={handleInstall}
          className="bg-coral text-white rounded-full px-4 text-sm"
        >
          Install
        </Button>
      </div>
    </div>
  );
};
